module.exports = __webpack_public_path__ + "img/FR_Mark_WHT.d41d013c.svg";